namespace TabAurous.OMS {
    export interface ServicesMasterForm {
        ServiceCode: Serenity.StringEditor;
        ServiceName: Serenity.StringEditor;
        CategoryId: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        DefaultTdsType: Serenity.LookupEditor;
    }

    export class ServicesMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ServicesMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ServicesMasterForm.init)  {
                ServicesMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(ServicesMasterForm, [
                    'ServiceCode', w0,
                    'ServiceName', w0,
                    'CategoryId', w1,
                    'TaxCode', w1,
                    'DefaultTdsType', w1
                ]);
            }
        }
    }
}
